@let t = templateGroup();

<span 
  class="group-name"
  [matTooltip]="t.name"
  [matTooltipShowDelay]="500">{{ t.name }}
</span>
<div class="template-count">{{ t?.referenceCount ?? 0 }}</div>
<div class="action-button-container">
  @for (action of actions; track action.icon) {
    <button
      class="button is-ghost"
      [matTooltip]="action.tooltip | translate"
      [matTooltipShowDelay]="500"
      (click)="action.onClick()">
      <i [class]="'icon ' + action.icon"></i>
    </button>
  }
</div>
